module.exports = __webpack_public_path__ + "static/media/logo-footer.945cb9b9.svg";